import React from "react";

const About = () => {
  return (
    <section className="section about-section">
      <h1 className="section-title">About Us</h1>
      <p>
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Iure, porro a tempore quod doloribus nostrum nemo sapiente nam consequatur suscipit harum labore repudiandae itaque praesentium iste. Reiciendis, soluta officia iure fugiat doloribus dolore quibusdam odio illo, ullam enim aut? Voluptatibus similique, aperiam voluptates ratione quidem dolor distinctio facere nulla numquam vero odio veritatis corporis velit quasi quod repellat corrupti voluptatem commodi aliquam obcaecati unde id nostrum cumque. Minima mollitia temporibus id hic aperiam quibusdam laboriosam culpa, qui facilis ex nihil iste nisi, neque omnis optio laborum ab deserunt, itaque perspiciatis atque perferendis? Cupiditate iure vero iste ipsum, odit enim aliquam.
      </p>
    </section>
  );
}

export default About
